import { render, staticRenderFns } from "./CMSCustomFieldDetailList.vue?vue&type=template&id=290048f4&"
import script from "./CMSCustomFieldDetailList.vue?vue&type=script&lang=js&"
export * from "./CMSCustomFieldDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports